import React from "react";
import hibiscus from "../images/hibiscus.webp";
import cloves from "../images/cloves.webp";
import ginger from "../images/ginger.webp";
import mint from "../images/mint.webp";

const ProductContent = () => {
  return (
    <div className="product-content brush-top brush-bottom">
      <div className="container full-height">
        <div className="header">
          <div>rodo comes packed with an arsenal of immunity boosting and life-nourishing herbs Rich</div>
        </div>

        <div className="content-wrapper">
          <div className="content-tile">
            <div className="title">Hibiscus</div>
            <img src={hibiscus} alt="hibiscus" />
            <p className="text-muted text">
              Rich in vitamins A, B-1 and C <br />
              Manages blood pressure
              <br />
              Lowers cholesterol <br />
            </p>
          </div>
          <div className="content-tile">
            <div className="title">mint</div>
            <img src={mint} alt="mint" />
            <p className="text-muted text">
              Aids in digestion <br />
              Mint is a stimulant that helps with weight loss
              <br />
              Quick nausea remedy <br />
            </p>
          </div>
          <div className="content-tile">
            <div className="title">ginger</div>
            <img src={ginger} alt="ginger" />
            <p className="text-muted text">
              Helps fight against cold and flu <br />
              Aids digestion <br />
              Prevents occurrence of stomach ulcer <br />
              Boosts bone health <br />
              Mitigates obesity <br />
              Good for heart health <br />
            </p>
          </div>
          <div className="content-tile">
            <div className="title">cloves</div>
            <img src={cloves} alt="cloves" />
            <p className="text-muted text">
              Anti-inflammatory <br />
              Boosts immune system <br />
              Helps with bone preservation <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductContent;
